import { Guid } from "@/types"

export interface ITenantEmployee {
    id: Guid
    forename: string
    surname: string
    number: string
    email: string
    phoneNumber: string
}

export default class TenantEmployee {
    id: Guid
    forename: string
    surname: string
    number: string
    email: string
    phoneNumber: string

    constructor(dto: ITenantEmployee) {
        this.id = dto.id
        this.forename = dto.forename
        this.surname = dto.surname
        this.number = dto.number
        this.email = dto.email
        this.phoneNumber =  dto.phoneNumber
    }

    toDto(): ITenantEmployee {
        return {
            id: this.id,
            forename: this.forename,
            surname: this.surname,
            number: this.number,
            email: this.email,
            phoneNumber:  this.phoneNumber,
        }
    }

    get fullName() {
        return [this.forename, this.surname].join(" ")
    }

    print() {
        return `${this.fullName} (${this.number})`
    }
}
